import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { EcomWrapperEventListenerEnumsObj } from "../enums/EcomWrapperEventListenerEnum";
import { getAdditionalInfo } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
export const dispatchEvent = (event, ecomWalletSdk, initParams, additionalInfo) => {
    let eventRequest = null;
    if (typeof event === "string" && ecomWalletSdk) {
        const ecomWrapperEvent = {
            clientTimestamp: Date.now(),
            sdk: BaseEcomSdkEnumsObj.PAYAIR_ECOM_WRAPPER_SDK,
            eventType: event,
            ecomWalletSdk: ecomWalletSdk,
            additionalInfo: getAdditionalInfo(additionalInfo),
            initParams: initParams,
        };
        if (!ecomWrapperEvent.initParams)
            delete ecomWrapperEvent.initParams;
        eventRequest = ecomWrapperEvent;
    }
    else
        eventRequest = event;
    window.dispatchEvent(new CustomEvent(EcomWrapperEventListenerEnumsObj.PAYAIR_ECOM_WRAPPER_SDK_LISTENER, { detail: eventRequest }));
};
